
import Vue from "vue";
import { LOYALTY_ROUTE_NAMES } from "@/loyalty-routes";
import { campaignAccess } from "@/helpers/loyaltyEditAccess";

export default Vue.extend({
  computed: {
    hasEditAccess() {
      return campaignAccess();
    }
  },
  data() {
    return {
      createNewRouteName: LOYALTY_ROUTE_NAMES.CAMPAIGNS_DETAILS
    };
  }
});
